import { env } from './constants';

/**
 * 環境変数に応じて Base URL を取得する
 */
export function getBaseUrl() {
  return env.VITE_API_BASE_URL;
}